import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import Tooltip from "@material-ui/core/Tooltip";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Modal, ModalHeader, ModalBody, Button, Label } from "reactstrap";
import { withRouter } from "react-router-dom";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

import { Card, CardBody, Col, Container, Row } from "reactstrap";

import BootstrapTable from "react-bootstrap-table-next";

// Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";

// Redux action
import { getStaffList, updateStaffList } from "store/staff/actions";

class StaffList extends Component {
  constructor(props) {
    super(props);

    const headerStyle = {
      backgroundColor: "#9fd0ff", // blue
      color: "#3a3d41ff",
      fontWeight: "600",
      textAlign: "center",
    };

    this.state = {
      selectedType: "All",
      modal: false,
      isEdit: false,
      selectedStaff: null,
      columns: [
        {
          dataField: "registered_at",
          text: "Registered Date",
          headerStyle: headerStyle,
          formatter: cell => {
            if (!cell) return "-";

            const date = new Date(cell);
            const day = String(date.getDate()).padStart(2, "0");
            const month = date.toLocaleString("en-GB", { month: "short" });
            const year = String(date.getFullYear()).slice(-2);

            return `${day}-${month}-${year}`;
          },
          filter: textFilter({ placeholder: "Enter Date" }),
        },
        {
          dataField: "name",
          text: "Name",
          headerStyle: headerStyle,
          filter: textFilter({ placeholder: "Enter Name" }),
        },
        {
          dataField: "email",
          text: "Email",
          headerStyle: {
            ...headerStyle,
            width: "220px",
          },
          style: {
            whiteSpace: "normal",
            wordBreak: "break-word",
            textAlign: "left",
          },
          filter: textFilter({ placeholder: "Enter Email" }),
        },
        {
          dataField: "phone",
          text: "Contact No.",
          headerStyle: { ...headerStyle, width: "140px" },
          style: { whiteSpace: "nowrap" },
          filter: textFilter({ placeholder: "Enter Contact" }),
        },
        {
          dataField: "cnic",
          text: "CNIC",
          headerStyle: { ...headerStyle, width: "150px" },
          style: { whiteSpace: "nowrap" },
          filter: textFilter({ placeholder: "Enter CNIC" }),
        },

        {
          dataField: "staff_type",
          text: "Staff Type",
          headerStyle: headerStyle,
          filter: selectFilter({
            options: {
              accountant: "Accountant",
              dispatcher: "Dispatcher",
              CSR: "CSR",
            },
          }),
        },
        {
          dataField: "city",
          text: "City",
          headerStyle: headerStyle,
          filter: textFilter({ placeholder: "Enter City" }),
        },
        {
          dataField: "status",
          text: "Status",
          headerStyle: headerStyle,
          filter: selectFilter({
            options: {
              Active: "Active",
              Inactive: "Inactive",
            },
          }),
        },
        {
          dataField: "menu",
          isDummyField: true,
          text: "Action",
          headerStyle: headerStyle,
          formatter: (cellContent, staff) => (
            <div className="d-flex gap-3 justify-content-center">
              <Tooltip title="Update">
                <i
                  className="mdi mdi-pencil font-size-18 text-success"
                  style={{ cursor: "pointer" }}
                  onClick={() => this.handleEditClick(staff)}
                />
              </Tooltip>
            </div>
          ),
        },
      ],
    };
  }

  handleEditClick = staff => {
    this.setState({
      selectedStaff: staff,
      isEdit: true,
      modal: true,
    });
  };

  toggleModal = () => {
    this.setState(prev => ({
      modal: !prev.modal,
    }));
  };

  handleTypeChange = e => {
    this.setState({ selectedType: e.target.value });
  };

  componentDidMount() {
    const authUser = localStorage.getItem("authUser");
    if (!authUser) return;

    const parsedUser = JSON.parse(authUser);
    this.props.getStaffList(parsedUser.user_id, parsedUser.organization_name);
  }

  render() {
    const { staffList = [], loading } = this.props;
    const { selectedType } = this.state;

    const filteredData =
      selectedType === "All"
        ? staffList
        : staffList.filter(s => s.staff_type === selectedType);

    const pageOptions = {
      sizePerPage: 10,
      totalSize: filteredData.length,
      custom: true,
      page: 1,
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Staff List | NEQAS</title>
          </MetaTags>

          <Container fluid>
            <Breadcrumbs title="Staff" breadcrumbItem="Staff List" />

            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <Row className="mb-3">
                      <Col md="3">
                        <select
                          value={selectedType}
                          onChange={this.handleTypeChange}
                          className="form-control"
                        >
                          <option value="All">All Staff</option>
                          <option value="accountant">Accountant</option>
                          <option value="dispatcher">Dispatcher</option>
                          <option value="CSR">CSR</option>
                        </select>
                      </Col>
                    </Row>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.columns}
                      data={filteredData}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={filteredData}
                          columns={this.state.columns}
                        >
                          {toolkitProps => (
                            <React.Fragment>
                              <div className="table-responsive">
                                <BootstrapTable
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  striped
                                  hover
                                  bordered={false}
                                  filter={filterFactory()}
                                  wrapperClasses="table-responsive"
                                  classes="table table-layout-fixed"
                                />
                              </div>

                              {/* ✅ Pagination footer */}
                              <Row className="align-items-md-center mt-3">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                    <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                      <ModalHeader toggle={this.toggleModal}>
                        Update Staff
                      </ModalHeader>

                      <ModalBody>
                        <Formik
                          enableReinitialize
                          initialValues={{
                            name: this.state.selectedStaff?.name || "",
                            email: this.state.selectedStaff?.email || "",
                            phone: this.state.selectedStaff?.phone || "",
                            cnic: this.state.selectedStaff?.cnic || "",
                            city: this.state.selectedStaff?.city || "",
                            status:
                              this.state.selectedStaff?.status || "Active",
                          }}
                          validationSchema={Yup.object({
                            name: Yup.string().required("Required"),
                            email: Yup.string()
                              .email("Invalid email format")
                              .required("Email is required"),
                            phone: Yup.string().required("Required"),
                            cnic: Yup.string().required("Required"),
                            city: Yup.string().required("Required"),
                            status: Yup.string().required("Status is required"),
                          })}
                          onSubmit={values => {
                            const updatedStaff = {
                              ...this.state.selectedStaff,
                              ...values, // 👈 status bhi yahin se jayega
                            };

                            this.props.updateStaffList(updatedStaff);
                            this.toggleModal();
                          }}
                        >
                          {({ submitForm }) => (
                            <Form>
                              {" "}
                              {/* ✅ Formik ka Form */}
                              <div className="mb-3">
                                <Label>Name</Label>
                                <Field name="name" className="form-control" />
                              </div>
                              <div className="mb-3">
                                <Label>Email</Label>
                                <Field name="email" className="form-control" />
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="text-danger mt-1"
                                />
                              </div>
                              <div className="mb-3">
                                <Label>Phone</Label>
                                <Field name="phone" className="form-control" />
                              </div>
                              <div className="mb-3">
                                <Label>CNIC</Label>
                                <Field name="cnic" className="form-control" />
                              </div>
                              <div className="mb-3">
                                <Label>City</Label>
                                <Field name="city" className="form-control" />
                              </div>
                              <div className="mb-3">
                                <Label>Status</Label>
                                <Field
                                  as="select"
                                  name="status"
                                  className="form-control"
                                >
                                  <option value="Active">Active</option>
                                  <option value="Inactive">Inactive</option>
                                </Field>
                              </div>
                              <div className="text-end">
                                <Button
                                  color="primary"
                                  type="button"
                                  onClick={() => {
                                    console.log("UPDATE BUTTON CLICKED");
                                    submitForm();
                                  }}
                                >
                                  Update
                                </Button>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </ModalBody>
                    </Modal>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

StaffList.propTypes = {
  staffList: PropTypes.array,
  loading: PropTypes.bool,
  getStaffList: PropTypes.func,
  updateStaffList: PropTypes.func,
};

const mapStateToProps = state => ({
  staffList: state.staff.staffList,
  loading: state.staff.loading,
});

const mapDispatchToProps = {
  getStaffList,
  updateStaffList,
};

export default connect(mapStateToProps, mapDispatchToProps)(StaffList);
